import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { clips } from "@/mocks/clips";

const featuredIds = ["entertainment-guest-clash", "ecommerce-price-war", "music-live-crack"];

export default function QuoteSpotlight() {
  const featured = featuredIds
    .map((id) => clips.find((clip) => clip.id === id))
    .filter((clip): clip is (typeof clips)[number] => Boolean(clip));

  return (
    <section className="mx-auto w-full max-w-content px-4 py-12 md:px-6 md:py-16" id="quotes">
      <SectionHeading
        eyebrow="主播关键发言"
        title="被反复引用的几句话，原文在这里"
        description="关键发言按时间点摘录，不修改措辞、不替换语气。想核对上下文，可以直接跳到对应片段的文字版。"
      />

      <div className="grid grid-cols-1 gap-5 lg:grid-cols-3">
        {featured.map((clip, index) => {
          const quote = clip.quotes[1] ?? clip.quotes[0];
          return (
            <figure
              key={clip.id}
              className={`flex flex-col rounded-lg border border-background-200 p-6 ${
                index === 1 ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-950"
              }`}
            >
              <i
                className={`ri-double-quotes-l text-3xl ${
                  index === 1 ? "text-background-50/70" : "text-primary-400"
                }`}
              />
              <blockquote
                className={`mt-4 flex-1 font-heading text-lg font-bold leading-relaxed md:text-xl ${
                  index === 1 ? "text-background-50" : "text-foreground-950"
                }`}
              >
                {quote.text}
              </blockquote>
              <figcaption
                className={`mt-6 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs font-label ${
                  index === 1 ? "text-background-100/85" : "text-foreground-500"
                }`}
              >
                <span>{quote.speaker}</span>
                <span>{clip.duration} 处 · {quote.time}</span>
              </figcaption>
              <Link
                to={`/clip/${clip.id}`}
                className={`mt-5 inline-flex w-fit items-center gap-1 whitespace-nowrap rounded-md px-4 py-2 text-xs font-label transition-colors ${
                  index === 1
                    ? "bg-background-50 text-primary-700 hover:bg-background-100 dark:bg-primary-950 dark:text-primary-100 dark:hover:bg-primary-900"
                    : "border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600"
                }`}
              >
                查看完整文字版
                <i className="ri-arrow-right-line" />
              </Link>
            </figure>
          );
        })}
      </div>
    </section>
  );
}